import styled from "styled-components";

export const Filters = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  padding: 0px;
`;

export const Button = styled("button")`
  padding: 0px;
  margin: 0px;
  border: 0px;
  background: none;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const Label = styled("span")`
  width: 14px;
  height: 14px;
  background: red;
  color: white;
  border-radius: 12px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 5px;
  right: 5px;
`;

export const ResetFilters = styled("button")`
  border-radius: 1rem;
  border: 1px solid #f2f2f2;
  padding: 0.5rem;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: none;

  :hover {
    background-color: #f2f2f2;
    border-color: #00000030;
  }
`;
